import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import InvoiceStatusForm, {
  InvoiceStatusFormFields,
} from '../../components/InvoiceStatus/InvoiceStatusForm';
import { useAuth } from '../../contexts/auth';
import api from '../../services/api';
import InvoiceStatusState, { isEditable } from '../../enums/InvoiceStatusState';

export default function InvoiceStatusesEdit() {
  const {
    user: { organization },
  } = useAuth();
  const { id } = useParams();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [formFields, setFormFields] = useState<InvoiceStatusFormFields>(
    null as unknown as InvoiceStatusFormFields
  );
  const [formErrors, setFormErrors] = useState({});

  async function getInvoiceStatus() {
    if (organization && id) {
      const response = await api.get(
        `organizations/${organization.id}/invoice-statuses/${id}`
      );

      if (!isEditable(response.data.state)) {
        navigate('/invoice-statuses');
        return;
      }

      setFormFields({
        state: response.data.state,
        label: response.data.label,
      });
      setIsLoading(false);
    }
  }

  const onSubmit = async (data: InvoiceStatusFormFields) => {
    try {
      await api.put(
        `organizations/${organization.id}/invoice-statuses/${id}`,
        data
      );

      navigate('/invoice-statuses');
    } catch (e: any) {
      if (e.response.data.errors) {
        setFormErrors(e.response.data.errors);
      }
    }
  };

  useEffect(() => {
    getInvoiceStatus();
  }, [organization, id]);

  return (
    <InvoiceStatusForm
      isLoading={isLoading}
      title={`Editar Situação de OS ${id}`}
      formFields={formFields}
      formErrors={formErrors}
      onSubmit={onSubmit}
    />
  );
}
